module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shortcuts text-dark"
  }, [_c('div', {
    staticClass: "shortcuts__buttons"
  }, [_c('label', {
    staticClass: "marg-10-right"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.shortcuts')) + ":")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.getAbsentUsers
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.show_all_absent')))]), _vm._v(" "), (_vm.isShowExternalShortCuts) ? _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": true,
      "propOffset": [5, 5]
    }
  }, [_c('button', {
    staticClass: "do-bttn dropdown-button",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Rapporter "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.schoolLinks), function(schoolLink) {
    return _c('li', {
      key: schoolLink.link,
      staticClass: "li-links__link"
    }, [_c('a', {
      attrs: {
        "href": schoolLink.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(schoolLink.title) + "\n            "), _c('svg', {
      staticClass: "tw-icon w-6 h-6",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      }
    })])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.isShowAbsentUsers) ? _c('div', {
    staticClass: "shortcuts__overlay__bg",
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [(_vm.isShowAbsentUsers) ? _c('div', {
    ref: "overlay",
    staticClass: "shortcuts__overlay text-dark",
    attrs: {
      "id": "printList"
    }
  }, [_c('div', {
    staticClass: "shortcuts__overlay__header"
  }, [_c('h2', {
    staticClass: "text-dark"
  }, [(_vm.isLoading) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.getting_all')))]) : _c('span', [_vm._v(_vm._s(_vm.absentUsers.length))]), _vm._v("\n          " + _vm._s(_vm.$t('vue2.substitute_hours.absent_in_the_period')) + " " + _vm._s(_vm.startDateFormatted) + " - " + _vm._s(_vm.endDateFormatted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "shortcuts__overlay__header__buttons"
  }, [_c('button', {
    staticClass: "no-print",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "shortcuts__overlay__close icon__bg-circle no-print",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('div', {
    staticClass: "shortcuts__users"
  }, [_c('div', {
    staticClass: "filters__for__reasons no-print"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n['filter_reasons'],
      "tags": _vm.absenceEventsTypes,
      "selectedTags": _vm.selectedReasonsToFilter
    },
    on: {
      "select": _vm.toggleFilter,
      "clear": function($event) {
        _vm.selectedReasonsToFilter = []
      }
    }
  })], 1), _vm._v(" "), (_vm.absenceEvents.length < 1) ? _c('h4', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.there_is_no_one_absent')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.visibleAbsentUsers), function(absentUser) {
    return _c('li', {
      key: absentUser.userCalendarId,
      staticClass: "shortcuts-user text-dark"
    }, [_c('div', {
      staticClass: "shortcuts-user__header"
    }, [_c('div', {
      staticClass: "shortcuts-user__header__name"
    }, [_vm._v(_vm._s(absentUser.name))]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.days_with_absence')) + ":")]), _vm._v("\n                " + _vm._s(absentUser.days.length) + "\n              ")])]), _vm._v(" "), _c('ul', {
      staticClass: "text-dark"
    }, _vm._l((absentUser.days), function(day) {
      return _c('li', {
        key: day.date
      }, [_c('ul', {
        staticClass: "events__list"
      }, _vm._l((day.items), function(item) {
        return _c('li', {
          key: item.key,
          staticClass: "events__list__event"
        }, [_c('div', {
          staticClass: "events__list__event__meta"
        }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(item.event.start))) + " " + _vm._s(_vm.$filters.LL(item.event.start)) + "\n                      kl. " + _vm._s(_vm.$filters.LT(item.event.start)) + " -\n                      "), (item.isMultiDay) ? [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(item.event.end))) + " " + _vm._s(_vm.$filters.LL(item.event.end)) + " kl.")] : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.$filters.LT(item.event.end)) + ",\n                      "), _c('b', [_vm._v(_vm._s(item.event.title))]), _vm._v(" "), (item.serial) ? _c('span', {
          staticClass: "events__list__event__period"
        }, [_vm._v("\n                        (" + _vm._s(_vm.i18n['period']) + ": " + _vm._s(_vm.$filters.LL(item.serial.from_date)) + " -\n                        " + _vm._s(item.serial.to_date ? _vm.$filters.LL(item.serial.to_date) : _vm.i18n['ongoing']) + ")\n                      ")]) : _vm._e()], 2), _vm._v(" "), (item.hasNote) ? _c('div', {
          staticClass: "events__list__event__note"
        }, [_c('span', {
          staticClass: "icon-pencil"
        }), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(item.event.teacher_notes)
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.duration))])])
      }), 0)])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMoreAbsentUsers),
      expression: "hasMoreAbsentUsers"
    }],
    ref: "loadMoreSentinel",
    staticClass: "shortcuts__load-more no-print"
  }, [_c('Loader', {
    attrs: {
      "isSmall": true
    }
  })], 1)])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06fea9d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hours/HoursShowShortcuts.vue
// module id = 1743
// module chunks = 1